import { useApolloClient } from "@apollo/client";
import { CardContainer } from "@msys/ui";
import { Stack, TextField } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { debounce } from "lodash-es";
import React from "react";
import {
  CrmCompanyOwnInformation_CrmCompanyFragment,
  useModifyCrmOrg_CrmCompanyOwnInformationMutation,
} from "./CrmCompanyOwnInformationAtCrmBox.generated.js";

export function CrmCompanyOwnInformation({
  crmCompany,
}: {
  crmCompany: CrmCompanyOwnInformation_CrmCompanyFragment;
}) {
  const { t } = useTranslate(["CrmOrganisations"]);

  const client = useApolloClient();
  const [modifyCrmOrganisation] =
    useModifyCrmOrg_CrmCompanyOwnInformationMutation({
      client,
    });

  const handleOwnClientIdChange = React.useMemo(
    () =>
      debounce(value => {
        modifyCrmOrganisation({
          variables: {
            input: [
              {
                id: crmCompany.id,
                crmOwningOrganisationClientId: value,
              },
            ],
          },
        });
      }, 500),
    [modifyCrmOrganisation, crmCompany.id]
  );

  return (
    <CardContainer
      title={t("Own information at {organisationName}", {
        ns: "CrmOrganisations",
        organisationName: crmCompany.title,
      })}
      isExpandable
    >
      <Stack direction="column" p={1} spacing={1}>
        <TextField
          label={t("Own client id")}
          defaultValue={crmCompany.crmOwningOrganisationClientId}
          onChange={event => {
            handleOwnClientIdChange(event.target.value);
          }}
        />
      </Stack>
    </CardContainer>
  );
}
